<template>
  <div class="panel-in-tab">
    <el-tabs v-model="activeTopTab" @tab-click="handleTopTabClick" class="tabs">
      <el-tab-pane :label="item.label" v-for="item in tables" :key="item.value" :name="item.value">
        <div slot="label">
          <span>{{ item.label }}</span>
          <el-badge :value="item.number" v-if="item.number"></el-badge>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 引入内容组件 -->
    <price-content v-if="activeTopTab === 'price'" @getNumber="getParentNumber" />
    <design-content v-else-if="activeTopTab === 'design'" @getNumber="getParentNumber" />
    <other-content v-else-if="activeTopTab === 'other'" @getNumber="getParentNumber" />
    <banner-content v-else-if="activeTopTab === 'banner'" @getNumber="getParentNumber" />
    <other-content
      v-else-if="activeTopTab === 'skuPromotion'"
      :adjust-content="'SKU推广名称'"
      :hide-adjust-content-filter="true"
      @getNumber="getParentNumber"
    />
  </div>
</template>

<script>
import PriceContent from './components/PriceContent.vue';
import DesignContent from './components/DesignContent.vue';
import OtherContent from './components/OtherContent.vue';
import BannerContent from './components/BannerContent.vue';

export default {
  name: 'CannotProcess',
  components: {
    PriceContent,
    DesignContent,
    OtherContent,
    BannerContent,
  },
  data() {
    return {
      activeTopTab: 'price',
      tables: [
        {
          value: 'price',
          label: '实际执行价格',
          number: '',
        },
        {
          value: 'design',
          label: '设计图',
          number: '',
        },
        {
          value: 'other',
          label: '其他信息',
          number: '',
        },
        {
          value: 'banner',
          label: '通栏图',
          number: '',
        },
        {
          value: 'skuPromotion',
          label: 'SKU推广名称',
          number: '',
        },
      ],
    };
  },
  mounted() {
    let query = this.$route.query;
    if (query.activeTab) {
      this.activeTopTab = query.activeTab;
    }
    this.getNumber();
  },
  methods: {
    handleTopTabClick() {
      // 处理顶部标签页切换
    },
    getNumber() {
      const data = new FormData()
      data.append('status', 4)
      this.$q.newProduct.adjustContentStatics({data: data}).then((res) => {
        this.tables[0].number = res.data.executePriceQty;
        this.tables[1].number = res.data.designPicQty;
        this.tables[2].number = res.data.otherQty;
        this.tables[3].number = res.data.fullWidthQty;
        this.tables[4].number = res.data.skuNameQty;
      });
    },
    getParentNumber() {
      this.getNumber();
      // 更新数量
      this.$emit('getNumber');
      this.$store.dispatch('menu/getMenusNum', {}, { root: true });
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  height 100%;
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
  >>> .el-badge
        left -4px
  >>> .el-badge__content
        background-color #f56c6c
</style>
